import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators, FormControl, FormGroup, FormArray } from '@angular/forms';
import moment from 'moment';
import { environment } from '../../../../environments/environment';
declare var require: any
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-closing-listing',
  templateUrl: './closing-listing.component.html',
  styleUrls: ['./closing-listing.component.scss']
})
export class ClosingListingComponent implements OnInit {
  
  private modalRef;
  add_closing_res: any;
  search: any;
  add_closing_res_length: any;
  editPositionForm: FormGroup;
  get_all_admins_res: any;
  selectedMoment: any;
  edit_closing_id: any;
  submitted = false;
  delete_closing_id: any;
  enteredPass: any;
  superAdminCode = '0801';
  imgUrl = environment.ImageUrl;
  get_closing_res: any;
  selected_file: File;
  url_download_link: any;
  url_type: any;
  show_uploaded_image_modal: any;


  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {

    this.closing_listing();
    this.get_all_admins();

    this.editPositionForm = this.fb.group({
      name: ["", [Validators.required]],
      position: ["", [Validators.required]],
      company: ["", [Validators.required]],
      salary: ["", [Validators.required]],
      admin_id: ["", [Validators.required]]
    });

  }

  get editPositionFormValidators() { return this.editPositionForm.controls; }

  closing_listing() {
    this.auth.closing_listing().subscribe((response: any) => {
      this.add_closing_res = response.body;
      this.add_closing_res_length = response.body.length;
    }, (e) => {
      this.toastr.error(e.error.message);
    });
  }

  get_all_admins() {
    this.auth.getAllSubadmins().subscribe((response: any) => {
      this.get_all_admins_res = response.body;
      
    }, (e) => {
      this.toastr.error(e.error.message);
    });
  }

  edit_closing_modal(modal, list) {
    this.modalRef = this.modalService.open(modal, { size: 'sm', ariaLabelledBy: 'modal-basic-title' });
    this.edit_closing_id = list.id;

    this.show_uploaded_image_modal = modal;

    let formData = new FormData();
    formData.append('closingId', this.edit_closing_id);

    this.auth.get_closing(formData).subscribe((response: any) => {      
      this.get_closing_res = response.body;
      this.url_download_link = this.imgUrl + response.body.doc;
      this.url_type = response.body.type;

      this.editPositionForm = this.fb.group({
        name: [response.body.name, [Validators.required]],
        position: [response.body.position, [Validators.required]],
        company: [response.body.company, [Validators.required]],
        salary: [response.body.salary, [Validators.required]],
        admin_id: [response.body.selectedAdminId, [Validators.required]]
      });

      let selectedDate = moment(response.body.startingDate).format('X');
      this.selectedMoment = new Date(parseInt(selectedDate) * 1000);

    }, (e) => {
      this.toastr.error(e.error.message);
    });
  }

  edit_closing() {
    this.submitted = true;

    if (this.editPositionForm.invalid) {
      return;
    }

    if(this.selectedMoment == 0 || this.selectedMoment == undefined || this.selectedMoment == null) {
      return;
    }

    const date = moment(this.selectedMoment).format("M-D-YYYY");

    let formData = new FormData();
    formData.append('closingId', this.edit_closing_id);
    formData.append('selectedAdminId', this.editPositionForm.value.admin_id);
    formData.append('name', this.editPositionForm.value.name);
    formData.append('position', this.editPositionForm.value.position);
    formData.append('company', this.editPositionForm.value.company);
    formData.append('salary', this.editPositionForm.value.salary);
    // formData.append('startingDate', this.addPositionForm.value.starting_date);
    formData.append('startingDate', date);
    formData.append('doc', this.selected_file)

    this.auth.edit_closing(formData).subscribe((response: any) => {      
      this.toastr.success(response.message);
      this.modalService.dismissAll();
      this.submitted = false;
      this.closing_listing();
    }, (e) => {
      this.toastr.error(e.error.message);
    });
  }

  openModalDelete(modal: any, list) {
    this.modalRef = this.modalService.open(modal, { size: 'lg', ariaLabelledBy: 'modal-basic-title' });
    this.delete_closing_id = list.id;
  }

  onOtpChange(event) { this.enteredPass = event; }

  onDeleteClosing() {
    if (this.enteredPass == undefined || this.enteredPass == '') {
      this.toastr.error('Please enter correct password.')
      return;
    }
    ((this.enteredPass) === this.superAdminCode) ? this.delete_closing() : this.toastr.error('Password is incorrect.');

  }
  
  delete_closing() {
    let formData = new FormData();
    formData.append('closingId', this.delete_closing_id);

    this.auth.delete_closing(formData).subscribe((response: any) => {      
      this.toastr.success(response.message);
      this.modalService.dismissAll();
      this.closing_listing();
    }, (e) => {
      this.toastr.error(e.error.message);
    });
  }

  onImageSelected1(files, event: any) {
    if (files.length === 0) {
      return;
    }

    // const mimeType = files[0].type;
    // if (mimeType.match(/application\/*/) == null) {
    //   // this.message = 'Only images are supported.';
    //   return;
    // }

    this.selected_file = <File>files[0];
  }

  downloadExcel() {
    let fileSplit = this.url_download_link.split(/\.(?=[^\.]+$)/);
    fileSplit = `download.${fileSplit[1]}`;
    FileSaver.saveAs(this.url_download_link, fileSplit);

  }

  showUploadedImage(modal) {
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, { size: 'sm', ariaLabelledBy: 'modal-basic-title' });

  }

  close_img_modal() {
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(this.show_uploaded_image_modal, { size: 'sm', ariaLabelledBy: 'modal-basic-title' });
  }

}
